// extracted by mini-css-extract-plugin
export default {"wrap":"Vq-z","fullWidth":"Wq-z","items":"Xq-z","featureCss":"Yq-z","disabled":"Zq-z","imgCss":"_q-z"};